import React, { createContext, useContext, useState, useCallback, useRef } from "react";
import { apiRequest } from "../utils/api";

const PurchaseItemsContext = createContext();

export const PurchaseItemsProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [order, setOrder] = useState({
    date: new Date().toISOString().split("T")[0],
    purchase_number: "",
    phone: "",
    email: "",
    customer_name: "",
    postal_code: "",
    address: "",
    birth_date: "",
    furigana: "",
    purchase_bonus: 0,
    shipping_adjustment: 0,
    total_amount: 0,
    total_items: 0,
    status: "",
    barcodeInput: "",
    isOrderLocked: true,
    customer: "",  // 顧客IDの初期値も空文字にする
  });
  const [purchaseOrderId, setPurchaseOrderId] = useState(null);
  const previousOrderIdRef = useRef(null);

  // **トータルを計算して更新**
  const updateTotals = useCallback(async () => {
    if (!purchaseOrderId) return; // 伝票がない場合は処理しない

    try {
      // 最新の明細データを取得
      const itemsData = await apiRequest(`inventory/purchase_orders/${purchaseOrderId}/items/`);

      // 総買取点数を計算
      const totalQuantity = itemsData.reduce((sum, item) => sum + item.quantity, 0);
      // 小計の合計
      const totalSubtotal = itemsData.reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

      // `purchase_bonus` と `shipping_adjustment` を取得
      const purchaseOrder = await apiRequest(`inventory/purchase_orders/${purchaseOrderId}/`);
      const { purchase_bonus, shipping_adjustment } = purchaseOrder;

      // `total_amount` を計算
      const totalAmount = totalSubtotal + parseFloat(purchase_bonus) + parseFloat(shipping_adjustment);

      // `total_items` & `total_amount` を更新
      await apiRequest(`inventory/purchase_orders/${purchaseOrderId}/`, "PUT", {
        total_items: totalQuantity,
        total_amount: totalAmount
      });
      // **フロントエンドの `order` も更新**
      setOrder((prev) => {
        if (
          prev.total_items === totalQuantity &&
          prev.total_amount === totalAmount
        ) return prev; // 差がなければ再設定しない

        return {
          ...prev,
          total_items: totalQuantity,
          total_amount: totalAmount,
        };
      });

    } catch (error) {
      console.error("Error updating total_items and total_amount:", error);
    }
  }, [purchaseOrderId]);

    // **最新の明細を取得**
  const fetchItems = useCallback(
    async (orderId = purchaseOrderId) => {
      const idToUse = orderId || purchaseOrderId;
      if (!idToUse) return;

      try {
        console.trace("暴走");
        const data = await apiRequest(`inventory/purchase_orders/${idToUse}/items/`, "GET");
        setItems(data);
        await updateTotals();
      } catch (error) {
        console.error("Error fetching items:", error);
      }
    },
    [purchaseOrderId, updateTotals]
  );





  const sanitizeOrderData = (data) => {
      return {
          date: data.date || new Date().toISOString().split("T")[0],
          purchase_number: data.purchase_number || "",
          phone: data.phone || "",
          email: data.email || "",
          customer_name: data.customer_name || "",
          postal_code: data.postal_code || "",
          address: data.address || "",
          birth_date: data.birth_date || "",
          furigana: data.furigana || "",
          purchase_bonus: data.purchase_bonus || 0,
          shipping_adjustment: data.shipping_adjustment || 0,
          total_amount: data.total_amount || 0,
          total_items: data.total_items || 0,
          status: data.status || "",
          barcodeInput: data.barcodeInput || "",
          isOrderLocked: data.isOrderLocked || true,
          customer: data.customer_id || "",
      };
  };
const fetchOrder = async (orderId) => {
    if (!orderId) return; // IDがない場合はスキップ
    try {
        const response = await apiRequest(`inventory/purchase_orders/${orderId}`);
        console.log("点火1")
         
        
        let customerData = {}; // 顧客情報の初期値

        if (response.customer) {
            try {
                const customerResponse = await apiRequest(`inventory/customers/${response.customer}/`);
                customerData = {
                    customer_id: customerResponse.id || "",
                    customer_name: customerResponse.name || "",
                    furigana: customerResponse.furigana || "",
                    phone: customerResponse.phone_number || "",
                    email: customerResponse.email || "",
                    postal_code: customerResponse.postal_code || "",
                    address: customerResponse.address || "",
                    birth_date: customerResponse.birth_date || "",
                };
            } catch (customerError) {
                console.error("Error fetching customer data:", customerError);
            }
        }
        console.log("点火2")


        setOrder(sanitizeOrderData({ ...response, ...customerData }));

        setItems(response.details || []); // 明細 (`details`) もセット
        fetchItems(orderId); // アイテム情報を更新
    } catch (error) {
        console.error("Error fetching order:", error);
    }
  };

    const setAndFetchPurchaseOrderId = async (orderId) => {
    console.log("🚀 呼び出し: setAndFetchPurchaseOrderId", orderId);

    if (orderId === previousOrderIdRef.current) {
      console.log("⛔ 同じIDなのでスキップ");
      return;
    }

    previousOrderIdRef.current = orderId;

    if (orderId) {
      setPurchaseOrderId(orderId); // 非同期更新、下では使わない

      try {
        await fetchOrder(orderId);
        await fetchItems(orderId);
      } catch (error) {
        console.error("データ取得エラー:", error);
      }
    } else {
      console.log("🆕 新規作成の初期化");
      setPurchaseOrderId(null); // 明示的に null にリセット
      setOrder({
        date: new Date().toISOString().split("T")[0],
        purchase_number: "",
        phone: "",
        email: "",
        customer: "",
        customer_name: "",
        postal_code: "",
        address: "",
        birth_date: "",
        furigana: "",
        purchase_bonus: 0,
        shipping_adjustment: 0,
        total_amount: 0,
        total_items: 0,
        status: "",
        barcodeInput: "",
        isOrderLocked: true,
      });
      setItems([]);
    }
  };


  return (
    <PurchaseItemsContext.Provider value={{
      items,
      setItems,
      purchaseOrderId,
      setPurchaseOrderId: setAndFetchPurchaseOrderId,
      fetchItems,
      updateTotals,
      order,
      setOrder ,
      fetchOrder,
      setAndFetchPurchaseOrderId,
    }}>
      {children}
    </PurchaseItemsContext.Provider>
  );
};

export const usePurchaseItems = () => useContext(PurchaseItemsContext);
